module.exports = { getConfig: function() {
    return null;
} };
